export default __webpack_public_path__ + "static/rocketship-hero-sm-15bcc67cf6e84c4bb80beddc03a68714.svg";